import styled, { css } from 'styled-components';
import { colors } from '../../../base/styled/variables.styled';
import { typography, fontWeights } from '../../../base/styled/typography.style';
export const MidiaCardContainer = styled.article `
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  background-color: ${({ $inverse }) => $inverse ? colors.brand500 : 'transparent'};
  overflow: hidden;
  width: 284px;
  
  &:hover {
    background-color: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
  }
`;
export const ImageColumn = styled.div `
  width: 100%;
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const ContentColumn = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0 8px;
  width: 100%;
`;
export const MetaColumn = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0 16px 16px 16px;
  width: 100%;
`;
export const CardTitle = styled.h3.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
  ${css(typography.headline4)}
  font-weight: ${fontWeights.regular};
  margin: 0;
  padding: 0 14px 0 12px;
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};

  strong {
    font-weight: ${fontWeights.bold};
    color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
  }
`;
export const TagWrapper = styled.div `
  margin-bottom: 4px;
`;
export const MetaItem = styled.div `
  display: flex;
  align-items: center;
  gap: 6px;
  ${typography.body3};
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral500};
  font-weight: ${fontWeights.medium};

  svg {
    width: 20px;
    height: 20px;
    fill: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
  }
`;
//# sourceMappingURL=MidiaCard.style.js.map